import {ApiVisa, BaseApiTemplateService, Core2Config} from "../../../shared";

import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Injectable} from '@angular/core';
import { EmailContainer } from "../../../../../../../models/mongodbSchema/aggregates";

@Injectable({ providedIn: 'root' })
export class EmailService extends BaseApiTemplateService<EmailContainer> {

  constructor(private http: HttpClient) {
    super();
    this.httpClient = http;
    this.apiUrl =  Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ALG_CC_MODULE + "email-thread"
    this.endpoint_path =  Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ALG_CC_MODULE + "email-thread"
    this.httpClient = http  
  }

  public setUrl(emailId: string, apiVisa: ApiVisa) {
    let baseUrl = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ALG_CC_MODULE + 'email-thread';

    this.apiUrl = Core2Config.DOMAIN_URL + baseUrl + `/${emailId}/email`;
    this.endpoint_path = baseUrl + `/${emailId}/email`;
  }


  public fetchMedia(emailThreadId: string, emailId: string, apiVisa: ApiVisa) {
    const url = this.apiUrl + `/${emailThreadId}/email/${emailId}/attachment`;

    return this.httpClient
      .get(
        url,
        {
          responseType: 'blob',
          headers: new HttpHeaders({
            'Content-Type': 'application/json',
            'tenant-code': apiVisa.tenantCode
          })
        }
      );
  }
}
